var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnjoy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 80,
    viewBox: "0 0 88 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 80H68C71.32 80 74.16 78 75.36 75.12L87.44 46.92C87.8 46 88 45.04 88 44V36C88 31.6 84.4 28 80 28H54.76L58.56 9.72L58.68 8.44C58.68 6.8 58 5.28 56.92 4.2L52.68 0L26.32 26.36C24.88 27.8 24 29.8 24 32V72C24 76.4 27.6 80 32 80ZM32 32L49.36 14.64L44 36H80V44L68 72H32V32ZM0 32H16V80H0V32Z",
    fill: "#EBDFC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnjoy);
export default __webpack_public_path__ + "static/media/enjoy.d4f548c92b915c13f4ae73b131366a52.svg";
export { ForwardRef as ReactComponent };